<template>
	<div class="input-container">
		<div class="input-checkbox">
			<span class="checkmark-container">
				<label class="checkbox">
					<input type="checkbox" :id="`on-index-${ value.id }`" v-model="value.on_index">
					<span class="checkmark"></span>
				</label>
			</span>
			<label :for="`on-index-${ value.id }`" class="input-checkbox-text">Show In List View</label>
		</div>
	</div>
</template>

<script>

export default {

	props: ['value'],

};

</script>
